import AppStoreBadgeEN from "images/download/app-store-badge/en.svg";
import AppStoreBadgeTR from "images/download/app-store-badge/tr.svg";
import AppStoreBadgeIT from "images/download/app-store-badge/it.svg";
import AppStoreBadgeNL from "images/download/app-store-badge/nl.svg";
import AppStoreBadgeDE from "images/download/app-store-badge/de.svg";
import AppStoreBadgeES from "images/download/app-store-badge/es.svg";
import AppStoreBadgeFR from "images/download/app-store-badge/fr.svg";

import PlayStoreBadgeEN from "images/download/play-store-badge/en.png";
import PlayStoreBadgeTR from "images/download/play-store-badge/tr.png";
import PlayStoreBadgeIT from "images/download/play-store-badge/it.png";
import PlayStoreBadgeNL from "images/download/play-store-badge/nl.png";
import PlayStoreBadgeDE from "images/download/play-store-badge/de.png";
import PlayStoreBadgeES from "images/download/play-store-badge/es.png";
import PlayStoreBadgeFR from "images/download/play-store-badge/fr.png";

import FdroidBadgeEN from "images/download/f-droid-badge/en.svg";
import FdroidBadgeTR from "images/download/f-droid-badge/tr.svg";
import FdroidBadgeIT from "images/download/f-droid-badge/it.svg";
import FdroidBadgeNL from "images/download/f-droid-badge/nl.svg";
import FdroidBadgeDE from "images/download/f-droid-badge/de.svg";
import FdroidBadgeES from "images/download/f-droid-badge/es.svg";
import FdroidBadgeFR from "images/download/f-droid-badge/fr.svg";

import WebSignupBadgeEN from "images/download/web-signup-badge/en.svg";
import WebSignupBadgeTR from "images/download/web-signup-badge/tr.svg";
import WebSignupBadgeIT from "images/download/web-signup-badge/it.svg";
import WebSignupBadgeNL from "images/download/web-signup-badge/nl.svg";
import WebSignupBadgeDE from "images/download/web-signup-badge/de.svg";
import WebSignupBadgeES from "images/download/web-signup-badge/es.svg";
import WebSignupBadgeFR from "images/download/web-signup-badge/fr.svg";

import DesktopDownloadBadgeEN from "images/download/desktop-download-badge/en.svg";
import DesktopDownloadBadgeTR from "images/download/desktop-download-badge/tr.svg";
import DesktopDownloadBadgeIT from "images/download/desktop-download-badge/it.svg";
import DesktopDownloadBadgeNL from "images/download/desktop-download-badge/nl.svg";
import DesktopDownloadBadgeDE from "images/download/desktop-download-badge/de.svg";
import DesktopDownloadBadgeES from "images/download/desktop-download-badge/es.svg";
import DesktopDownloadBadgeFR from "images/download/desktop-download-badge/fr.svg";

import React, { PropsWithChildren } from "react";
import ExternalLink from "components/links/ExternalLink";
import { Link } from "gatsby";

interface ButtonProps {
    link: string;
    source: string;
    lang?: string;
    width: number;
    height: number;
}

const BadgeContainer: React.FC<PropsWithChildren> = ({ children }) => (
    <div className="d-flex justify-content-center align-items-center">
        {children}
    </div>
);

type Store = "appstore" | "playstore" | "fdroid" | "web" | "desktop";
type Lang = "en" | "tr" | "it" | "nl" | "de" | "es" | "fr";

const badgeMap: Record<Store, Record<Lang, string>> = {
    appstore: {
        en: AppStoreBadgeEN,
        tr: AppStoreBadgeTR,
        it: AppStoreBadgeIT,
        nl: AppStoreBadgeNL,
        de: AppStoreBadgeDE,
        es: AppStoreBadgeES,
        fr: AppStoreBadgeFR,
    },
    playstore: {
        en: PlayStoreBadgeEN,
        tr: PlayStoreBadgeTR,
        it: PlayStoreBadgeIT,
        nl: PlayStoreBadgeNL,
        de: PlayStoreBadgeDE,
        es: PlayStoreBadgeES,
        fr: PlayStoreBadgeFR,
    },
    fdroid: {
        en: FdroidBadgeEN,
        tr: FdroidBadgeTR,
        it: FdroidBadgeIT,
        nl: FdroidBadgeNL,
        de: FdroidBadgeDE,
        es: FdroidBadgeES,
        fr: FdroidBadgeFR,
    },
    web: {
        en: WebSignupBadgeEN,
        tr: WebSignupBadgeTR,
        it: WebSignupBadgeIT,
        nl: WebSignupBadgeNL,
        de: WebSignupBadgeDE,
        es: WebSignupBadgeES,
        fr: WebSignupBadgeFR,
    },
    desktop: {
        en: DesktopDownloadBadgeEN,
        tr: DesktopDownloadBadgeTR,
        it: DesktopDownloadBadgeIT,
        nl: DesktopDownloadBadgeNL,
        de: DesktopDownloadBadgeDE,
        es: DesktopDownloadBadgeES,
        fr: DesktopDownloadBadgeFR,
    },
};

export const AppStoreButton: React.FC<ButtonProps> = ({
    link,
    source,
    lang,
    width,
    height,
}) => (
    <BadgeContainer>
        <ExternalLink href={link} id={`${source}-appstore-download-button`}>
            <img
                src={badgeMap["appstore"][(lang as Lang) ?? "en"]}
                width={width}
                height={height}
                alt="Download Ente on the iOS App Store"
                loading="lazy"
            />
        </ExternalLink>
    </BadgeContainer>
);

export const PlayStoreButton: React.FC<ButtonProps> = ({
    link,
    source,
    lang,
    width,
    height,
}) => (
    <BadgeContainer>
        <ExternalLink href={link} id={`${source}-playstore-download-button`}>
            <img
                src={badgeMap["playstore"][(lang as Lang) ?? "en"]}
                width={width}
                height={height}
                alt="Download Ente on the Google Play Store"
                loading="lazy"
            />
        </ExternalLink>
    </BadgeContainer>
);

export const FDroidButton: React.FC<ButtonProps> = ({
    link,
    source,
    lang,
    width,
    height,
}) => (
    <BadgeContainer>
        <ExternalLink href={link} id={`${source}-fdroid-download-button`}>
            <img
                src={badgeMap["fdroid"][(lang as Lang) ?? "en"]}
                width={width}
                height={height}
                alt="Download Ente on F-Droid"
                loading="lazy"
            />
        </ExternalLink>
    </BadgeContainer>
);

export const WebButton: React.FC<ButtonProps> = ({
    link,
    source,
    lang,
    width,
    height,
}) => (
    <BadgeContainer>
        <ExternalLink href={link} id={`${source}-web-download-button`}>
            <img
                src={badgeMap["web"][(lang as Lang) ?? "en"]}
                width={width}
                height={height}
                alt="Sign into the Ente web app"
                loading="lazy"
            />
        </ExternalLink>
    </BadgeContainer>
);

export const DesktopButton: React.FC<ButtonProps> = ({
    link,
    source,
    lang,
    width,
    height,
}) => (
    <BadgeContainer>
        <Link to={link} id={`${source}-desktop-download-button`}>
            <img
                src={badgeMap["desktop"][(lang as Lang) ?? "en"]}
                width={width}
                height={height}
                alt="Download Ente's desktop app"
                loading="lazy"
            />
        </Link>
    </BadgeContainer>
);
